import { User } from 'app/core/models/user.types';
import { Task } from '@tasks/tasks.types';
import { Project } from 'app/modules/projects/projects.types';
import { RelatedToType } from 'app/shared/enums';

export enum ApprovalStatus {
  NONE = 'none',
  NOT_SENT = 'not_sent',
  NOT_YET = 'not_yet',
  APPROVED = 'approved',
  DECLINED = 'declined',
}

export interface Approval {
  active: boolean;
  approvable_url?: string;
  assigned_user: Partial<User>;
  assigned_user_id?: number;
  comments: string;
  id: number;
  meta?: Record<string, any>;
  related_to_id?: number;
  related_to_type?: RelatedToType;
  related_to?: Task | Project;
  status: ApprovalStatus;
}

export interface Approvable {
  approvals: Approval[];
}

export type ApprovalStatusLabels = Partial<Record<ApprovalStatus, string>>;

export const DEFAULT_APPROVAL_STATUS_LABELS: Record<ApprovalStatus, string> = {
  [ApprovalStatus.NONE]: 'Request not sent',
  [ApprovalStatus.NOT_SENT]: 'Request not sent',
  [ApprovalStatus.NOT_YET]: 'Awaiting approval',
  [ApprovalStatus.APPROVED]: 'Approved',
  [ApprovalStatus.DECLINED]: 'Approval denied',
};
